import { createAsyncThunk } from "@reduxjs/toolkit";
import { 
  activateDeactivateHumanCategories,
  addHumanCategories,
  deleteHumanCategories,
  getHumanCategories,
  getTableColumnNames,
  updateHumanCategories,
  uploadImages
} from "../../helpers/fakebackend_helper";
import { toast } from "react-toastify";
import { t } from "i18next";


// Fetch Human Category Table Column Names
export const fetchHumanCategoriesTableColumnNames = createAsyncThunk(
  "humanCategories/fetchHumanCategoriesTableColumnNames",
  async (humanCategories, thunkAPI) => {
    try {
      const response = await getTableColumnNames(humanCategories);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error || "Something went wrong");
    }
  }
);

export const uploadCategoryIcon = createAsyncThunk(
  "humanCategories/uploadImageFile",
  async (formData, { rejectWithValue }) => {
    try {
      const response = await uploadImages(formData);
      return response.data; 
    } catch (error) {
      return rejectWithValue(error || error.message || "Error uploading PDF Thumbnail");
    }
  }
);

export const uploadDarkIcon = createAsyncThunk(
  "humanCategories/uploadDarkIcon",
  async (formData, thunkAPI) => {
    try {
      const response = await uploadImages(formData);
      return response.data;
    } catch (err) {
      return thunkAPI.rejectWithValue(err.response?.data || err.message);
    }
  }
);

// Fetch Human Categories
export const fetchHumanCategories = createAsyncThunk(
  "humanCategories/fetch",
  async (_, { rejectWithValue }) => {
    try {
      const response = await getHumanCategories();
      return response.data;
    } catch (error) {
      return rejectWithValue(error || "Error fetching human categories");
    }
  }
);

// Add Human Categories
export const addHumanCategory = createAsyncThunk(
  "humanCategories/add",
  async (category, { rejectWithValue }) => {
    try {
      const response = await addHumanCategories(category);
        toast.success(t(response.message));
      return response.data;
    } catch (error) {
      return rejectWithValue(error || "Error adding human category");
    }
  }
);

// Update Human Categories
export const updateHumanCategory = createAsyncThunk(
  "humanCategories/update",
  async (category, { rejectWithValue }) => {
    try {
      const response = await updateHumanCategories(category);
      toast.success(t(response.message));
      return response.data;
    } catch (error) {
      return rejectWithValue(error || "Error updating human category");
    }
  }
);

// Delete Human Categories
export const deleteHumanCategory = createAsyncThunk(
  "humanCategories/delete",
  async (category, { rejectWithValue }) => {
    try {
      const response = await deleteHumanCategories(category);
      toast.success(t(response.message));
      return response.data;
    } catch (error) {
      return rejectWithValue(error || "Error deleting human category");
    }
  }
);

// Active Deactive Human Categories
export const activateDeactivateHumanCategory = createAsyncThunk(
  "humanCategories/activateDeactivate",
  async (category, { rejectWithValue }) => {
    try {
      const response = await activateDeactivateHumanCategories(category);      
      toast.success(t(response.message));
      return response.data;
    } catch (error) {
      return rejectWithValue(error || "Error activating/deactivating human category");
    }
  }
);

